<template>
  <div>
    <ht-table ref="list" v-loading="isLoading" :data="list">
      <ht-table-column label="序号" type="index" fixed="left" />
      <ht-table-column v-for="i in labelToProps" :key="`${i.prop}-${i.secondProp}`" :label="i.label" :prop="i.prop">
        <template v-slot="{row}">
          <span v-if="i.format === 'changeDate'">
            {{ row[i.prop] | formatTime }}
          </span>
          <span v-else>
            <span v-if="i.secondProp">{{ (row[i.prop] && row[i.prop][i.secondProp]) ? row[i.prop][i.secondProp] : '-' }}</span>
            <span v-else>{{ row[i.prop] ? row[i.prop] : '-' }}</span>
          </span>
        </template>
      </ht-table-column>
      <!--      <ht-table-column-operation>-->
      <!--        <template v-slot="{row}">-->
      <!--          <ht-button type="text" @click="gotoView(row.code, row.id)">详情</ht-button>-->
      <!--          <ht-popover-button-->
      <!--            type="text"-->
      <!--            :danger-text="true"-->
      <!--            confirm-title="请确认是否要删除该条数据？"-->
      <!--          >删除-->
      <!--          </ht-popover-button>-->
      <!--        </template>-->
      <!--      </ht-table-column-operation>-->
    </ht-table>
    <ht-pagination
      style="float: right;margin-bottom: 10px"
      :total="page.total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.perPage"
      @pagination="getList"
    />
  </div>
</template>

<script>
import HtListContainer from '@/components/HtListContainer/index'
import { getEquipmentOfBugReportsApi } from '@/api/devicesMgr/deviceMgr'

export default {
  name: 'BugReports',
  extends: HtListContainer,
  props: {
    deviceCode: {
      type: [Number, String],
      default: undefined
    }
  },
  data() {
    return {
      labelToProps: [
        {
          label: '缺陷单号',
          prop: 'code'
        },
        {
          label: '专业',
          prop: 'major'
        },
        {
          label: '设备编号',
          prop: 'equipment',
          secondProp: 'code'
        },
        {
          label: '设备名称',
          prop: 'equipment',
          secondProp: 'name'
        },
        {
          label: '发现人',
          prop: 'finderAccount',
          secondProp: 'personName'
        },
        {
          label: '创建人',
          prop: 'approveAccount',
          secondProp: 'personName'
        },
        {
          label: '创建时间',
          prop: 'findDate',
          format: 'changeDate'
        },
        {
          label: '缺陷修复类型',
          prop: 'bugRepairType'
        },
        {
          label: '描述',
          prop: 'description'
        },
        {
          label: '审核人',
          prop: 'leadingAccount',
          secondProp: 'personName'
        },
        {
          label: '处理方式',
          prop: 'processMode'
        },
        {
          label: '建议',
          prop: 'suggestion'
        },
        {
          label: '任务单号',
          prop: 'task',
          secondProp: 'code'
        },
        {
          label: '缺陷来源',
          prop: 'bugSource'
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.beforeGetList()
      getEquipmentOfBugReportsApi(this.deviceCode).then((resp) => {
        this.afterGetList(resp)
      })
    }
  }

}
</script>

<style scoped>

</style>
